import React, { useContext } from 'react';
import { AuthContext } from './AuthContext';
import { Navigate, useLocation } from 'react-router-dom';

const ProtectedRoute = ({ children, requiredRoles = [], redirectPath = "/login" }) => {
    const { accessToken, user } = useContext(AuthContext);
    const location = useLocation();

    // Skip redirect for specific paths
    const skipRedirectPaths = ['/forgotpassword', '/set-password'];
    const shouldSkipRedirect = skipRedirectPaths.some(path => location.pathname.startsWith(path));

    // Check if the user is authenticated
    if (!accessToken && !shouldSkipRedirect) {
        return <Navigate to={redirectPath} />;
    }

    // Check if the user has any of the required roles
    if (
        requiredRoles.length > 0 &&
        (!user || !user.roles || !user.roles.some(role => requiredRoles.includes(role)))
    ) {
        return <Navigate to="/unauthorized" />;
    }

    // Render the protected content
    return children;
};

export default ProtectedRoute;
